import { Show, For } from "solid-js"
import type { MarketplaceSkill } from "./skill-market-types"
import { SkillMarketIcon } from "./skill-market-icon"

export function SkillMarketCard(props: {
  skill: MarketplaceSkill
  selected: boolean
  onSelect: () => void
  onInstall: () => void
}) {
  const installed = () => Boolean(props.skill.is_installed_global || props.skill.is_installed_project)
  // 评分为 0 / 未评分时不展示，避免「★ 0.0」这种反而掉信任的信息
  const rating = () => (props.skill.rating && props.skill.rating > 0 ? props.skill.rating : undefined)

  return (
    <div
      class="skill-market-card"
      classList={{ "skill-market-card--selected": props.selected }}
      onClick={props.onSelect}
    >
      <div class="skill-market-card-head">
        <SkillMarketIcon skill={props.skill} size={36} />
        <div class="skill-market-card-headtext">
          <div class="skill-market-card-title">
            <span class="skill-market-card-name">{props.skill.display_name ?? props.skill.name}</span>
            <Show when={props.skill.version}>
              <span class="skill-market-card-version">v{props.skill.version}</span>
            </Show>
          </div>
          <Show when={props.skill.author}>
            <span class="skill-market-card-author">{props.skill.author}</span>
          </Show>
        </div>
      </div>

      <p class="skill-market-card-desc">{props.skill.description ?? ""}</p>

      <Show when={props.skill.tags && props.skill.tags.length > 0}>
        <div class="skill-market-card-tags">
          <For each={props.skill.tags!.slice(0, 3)}>
            {(tag) => <span class="skill-market-card-tag">{tag}</span>}
          </For>
        </div>
      </Show>

      <div class="skill-market-card-footer">
        <div class="skill-market-card-meta">
          <span>{props.skill.install_count ?? 0} 次安装</span>
          <Show when={rating()}>
            <span class="skill-market-card-meta-dot">·</span>
            <span>{rating()!.toFixed(1)} 分</span>
          </Show>
        </div>
        <Show
          when={!installed()}
          fallback={<span class="skill-market-card-installed-label">已安装</span>}
        >
          <button
            class="skill-market-card-install-btn"
            onClick={(e) => {
              e.stopPropagation()
              props.onInstall()
            }}
          >
            安装
          </button>
        </Show>
      </div>
    </div>
  )
}
